module.exports = __webpack_public_path__ + "img/pop_lu@2x.1956cfd6.png";